import { CountryCode, DEFAULT_COUNTRY_CODE } from "@nf/constants";

export interface CountryRoutesConfig {
  HOME: string;
  DANSK?: string;
  KIDS: string;
}

export const COUNTRY_ROUTES: Record<string, CountryRoutesConfig> = {
  [CountryCode.Danish]: {
    HOME: "/hjem",
    DANSK: "/danskfilmskat",
    KIDS: "/boern",
  },
  [CountryCode.Finnish]: {
    HOME: "/home",
    KIDS: "/kids",
  },
};

export function getCountryRoutes(country: string): CountryRoutesConfig {
  const code = country.toUpperCase();
  return COUNTRY_ROUTES[code] || COUNTRY_ROUTES[DEFAULT_COUNTRY_CODE];
}
